/* eslint no-console: 0 */
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useModalState } from '../../../hooks/modal/ModalStateProvider.tsx';
import screenNavigator from '../../../services/ScreenNavigator';
import { triggerHapticFeedback } from '../../../hapticFeedback';

interface DeviceMapModalHeaderProps { 
  onClose: any;
}

/**
 * Component that lists devices belonging to the user.
 */
export const DeviceMapModalHeader: React.FC<DeviceMapModalHeaderProps> = ({ onClose }) => {

  const history = useHistory();
  const { title } = useModalState();

  const onCloseWrapped = useCallback(() => {
    if (onClose) {
      triggerHapticFeedback();
      onClose();
    }
  }, [onClose]);

  return (
    <div className="deviceMapModalWindow_header">
      <div className="deviceMapModalWindow_titleBar">
        <a className="deviceMapModalWindow_iconButton" onClick={onCloseWrapped}>
          {screenNavigator.exitProps(history).iconType === 'close' ? <CloseIcon /> : <ArrowBackIcon />}
        </a>
        <span className="titleText">{title}</span>
        <span className="deviceMapModalWindow_iconButton"></span>
      </div>
    </div>
  );
};
